import _asyncToGenerator from "/data/landun/workspace/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.function.name.js";
import "regenerator-runtime/runtime.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-c374c7e4"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "text"
  }, "关联空间列表", -1);
});

var _hoisted_2 = {
  class: "title"
};

var _hoisted_3 = /*#__PURE__*/_createTextVNode(" 当前选择业务");

var _hoisted_4 = {
  class: "text"
};
var _hoisted_5 = {
  class: "table"
};
var _hoisted_6 = ["onClick"];
var _hoisted_7 = {
  class: "pager"
};
import { ref, reactive, watchEffect, watch } from 'vue';
import Pagination from '@/components/pagination.vue';
import AuthService from '@/api/auth';
import { useRouter } from 'vue-router';
import LoadingSlot from './loading.vue';
import TableEmpty from './tableEmpty.vue';
export default /*#__PURE__*/_defineComponent({
  props: {
    detailData: {
      type: Object,
      defaultValue: {}
    },
    visible: Boolean,
    corporationId: String
  },
  emits: ['close'],
  setup: function setup(__props, _ref) {
    var emits = _ref.emit;
    var props = __props;
    var router = useRouter();
    var tableLoading = ref(false);
    var pagination = reactive({
      total: 0
    });
    var tableData = ref([]);
    var pager = reactive({
      current: 1,
      pageSize: 10
    });
    var drawerVisible = ref(props.visible);
    watchEffect(function () {
      drawerVisible.value = props.visible;
    });

    var handleDetail = function handleDetail(e, row) {
      router.push({
        name: 'SpaceBasic',
        params: {
          company_id: row.corporationId,
          biz_url: row.id
        }
      });
    };

    var fetchBizList = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(bizNameOrId) {
        var _props$detailData, _data$data;

        var data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                tableLoading.value = true;
                _context.next = 3;
                return AuthService.getBizList({
                  corporationId: props.corporationId,
                  busiId: ((_props$detailData = props.detailData) === null || _props$detailData === void 0 ? void 0 : _props$detailData.busiId) || '',
                  pageNo: pager.current,
                  pageSize: pager.pageSize
                });

              case 3:
                data = _context.sent;
                tableLoading.value = false;

                if (((_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.code) === 1) {
                  tableData.value = data.data.result.itemList;
                  pagination.total = data.data.result.totalCount;
                }

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function fetchBizList(_x) {
        return _ref2.apply(this, arguments);
      };
    }();

    var closeHandler = function closeHandler() {
      emits('close');
    };

    watch(function () {
      return props.visible;
    }, function (newVal) {
      if (newVal) {
        fetchBizList();
      }
    });

    var onChangePage = function onChangePage(detail) {
      if (detail.pageSize) {
        pager.pageSize = detail.pageSize;
      }

      if (detail.pageNo) {
        pager.current = detail.pageNo;
      }

      fetchBizList();
    };

    return function (_ctx, _cache) {
      var _component_el_table_column = _resolveComponent("el-table-column");

      var _component_el_table = _resolveComponent("el-table");

      var _component_el_drawer = _resolveComponent("el-drawer");

      return _openBlock(), _createBlock(_component_el_drawer, {
        modelValue: drawerVisible.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return drawerVisible.value = $event;
        }),
        "show-close": false,
        size: 800,
        onClose: closeHandler,
        "custom-class": "associate-drawer"
      }, {
        title: _withCtx(function () {
          return [_createElementVNode("div", {
            class: "drawer-title"
          }, [_hoisted_1, _createElementVNode("i", {
            class: "iconfont iconclose-line",
            onClick: closeHandler
          })])];
        }),
        default: _withCtx(function () {
          var _props$detailData2;

          return [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("span", _hoisted_4, _toDisplayString((_props$detailData2 = __props.detailData) === null || _props$detailData2 === void 0 ? void 0 : _props$detailData2.busiName), 1)]), _createElementVNode("div", _hoisted_5, [_createVNode(LoadingSlot, {
            loading: tableLoading.value
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_table, {
                data: tableData.value,
                style: {
                  "width": "100%"
                },
                "header-row-class-name": "table-header"
              }, {
                empty: _withCtx(function () {
                  return [_createVNode(TableEmpty, {
                    emptyText: "暂无数据"
                  })];
                }),
                default: _withCtx(function () {
                  return [_createVNode(_component_el_table_column, {
                    label: "空间ID"
                  }, {
                    default: _withCtx(function (scope) {
                      return [_createTextVNode(_toDisplayString(scope.row.id), 1)];
                    }),
                    _: 1
                  }), _createVNode(_component_el_table_column, {
                    label: "空间名称"
                  }, {
                    default: _withCtx(function (scope) {
                      return [_createTextVNode(_toDisplayString(scope.row.name), 1)];
                    }),
                    _: 1
                  }), _createVNode(_component_el_table_column, {
                    label: "操作"
                  }, {
                    default: _withCtx(function (scope) {
                      return [_createElementVNode("span", {
                        onClick: function onClick($event) {
                          return handleDetail(scope.$index, scope.row);
                        },
                        class: "operate detail"
                      }, "详情", 8, _hoisted_6)];
                    }),
                    _: 1
                  })];
                }),
                _: 1
              }, 8, ["data"])];
            }),
            _: 1
          }, 8, ["loading"]), _createElementVNode("div", _hoisted_7, [_createVNode(Pagination, {
            options: _unref(pagination),
            params: _unref(pager),
            onOnChange: onChangePage
          }, null, 8, ["options", "params"])])])];
        }),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
});